"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientErrorMessages = void 0;
var ClientErrorMessages;
(function (ClientErrorMessages) {
    ClientErrorMessages["FALLBACK"] = "Unable to resolve request";
    ClientErrorMessages["GET_USER_ID"] = "No user id found in given access methods";
    ClientErrorMessages["CHECK_ACCESS_STATUS"] = "Invalid check access status method";
    ClientErrorMessages["CHECK_ACTIVATION_CODE_STATUS_CHANGE"] = "Check activation code status change timed out on the client";
    ClientErrorMessages["MISSING_REQUIRED_PARAMS"] = "Missing required request parameters - clientId or countryCode - use AuthSuiteSdkSetup.setAuthSuiteRequestData to initialize params";
})(ClientErrorMessages = exports.ClientErrorMessages || (exports.ClientErrorMessages = {}));
